module.exports = __webpack_public_path__ + "957953284229a254588bfb9b1b6babc1.otf";